<template>
  <div class="chip-container">
    <slot />
    <div v-if="text" :style="{ backgroundColor }" :class="['chip-badge', size ]">
      {{ text }}
    </div>
  </div>
</template>

<script lang="ts" setup>

// INTERFACES

interface ChipProps {
  text: string | number;
  color?: string;
  size?: Size;
}

// PROPS

const props = withDefaults(defineProps<ChipProps>(), {
  color: '#F44336',
  size: 'small',
});

// COMPUTEDS

const backgroundColor = computed(() => resolvedColor(props.color));

</script>

<style scoped>
.chip-container {
  position: relative;
  display: inline-block;
}
.chip-badge {
  pointer-events: none;
  position: absolute;
  top: 0;
  right: 0;
  transform: translate(50%, -50%);
  color: white;
  border-radius: 50%;
  min-width: 20px;
  height: 20px;
  font-size: 0.75rem;
  font-weight: bold;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  line-height: 1;
}
.chip-badge.small {
  min-width: 15px;
  height: 15px;
  font-size: 0.625rem;
}
.chip-badge.medium {
  min-width: 20px;
  height: 20px;
  font-size: 0.75rem;
}
.chip-badge.large {
  min-width: 25px;
  height: 25px;
  font-size: 1rem;
}
</style>
